<template>
  <Grid>
    <Cell
      size="12"
      tablet="6">
      <Btn
        color="cta"
        full-width="all"
        icon-left="Device/phone-line"
        :href="telephone.href"
        data-test-id="contact-phone-button"
        @click="pushToDatalayer('belOns', 'contact')">
        {{ telephone.text }}
      </Btn>
    </Cell>
    <Cell
      class="h-margin-bottom-xl"
      size="12"
      tablet="6">
      <Btn
        color="cta"
        full-width="all"
        :href="email.href"
        icon-left="Business/mail-line"
        data-test-id="contact-email-button"
        @click="pushToDatalayer('mailOns', 'contact')">
        {{ email.text }}
      </Btn>
    </Cell>
  </Grid>
</template>
<script setup>
const { $lang, $bus } = useNuxtApp()
const telephone = computed(() => {
  if ($lang === 'de') {
    return {
      href: 'tel:004939292678217',
      text: '+49 39 292 678 217'
    }
  }

  return {
    href: 'tel:0031850471747',
    text: '+31 85 04 71 747'
  }
})
const email = computed(() => {
  if ($lang === 'de') {
    return {
      href: 'mailto:service@gutsgusto.de',
      text: 'service@gutsgusto.de'
    }
  }

  return {
    href: 'mailto:info@gutsgusto.com',
    text: 'info@gutsgusto.com'
  }
})

const pushToDatalayer = (action, label) => {
  $bus.$emit('event-contact', {
    eventId: Date.now(),
    sourceUrl: document.location.href,
    action,
    label
  })
}

</script>
